/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedResListResponse } from '../types/PaginatedResList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type ResListRequest = {} | null | undefined;
export type ResListResponse = PaginatedResListResponse;

export type ResListQuery = {
  /**
   * ```yaml
   * in: query
   * name: birth_number__icontains
   * schema:
   *   type: string
   * ```
   */
  birth_number__icontains?: string;

  /**
   * ```yaml
   * in: query
   * name: ico__icontains
   * schema:
   *   type: string
   * ```
   */
  ico__icontains?: string;

  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;
};

/**
 * GET /dmx-server/res/
 *
 * ```yaml
 * operationId: res_list
 * tags:
 *   - res
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedResList'
 *     description: ''
 * ```
 */
export const resListOperation = (rest?: ResListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/res/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/res/' };
  };

/**
 * GET /dmx-server/res/
 *
 * ```yaml
 * operationId: res_list
 * tags:
 *   - res
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedResList'
 *     description: ''
 * ```
 */
export const resList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: ResListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedResListResponse>> => {
  const operation = resListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/res/
 */
export const useResListResource = (
  query: ResListQuery | null,
  useCached?: boolean,
): UseResource<ResListResponse> => {
  return useResource<ResListResponse>({
    path: query === null ? null : resListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
